import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DealerDetailType } from "../../dashboard/types/DealerDetailType";
import { apiClient } from "src/utils/Api/apiClient";

interface allDealerState {
        dealerDetail: DealerDetailType;
        dealerDetailLoading: boolean;
        dealerDetailError: string | null;
}

const initialState: allDealerState = {
        dealerDetail: {
                DealerId: "",
                DealerName: "",
                TotalNumberOfDoors: 0,
                TotalNumberOfInstances: 0,
                TotalNumberOfLocations: 0,
                TotalNumberOfLocationsOnline: 0
        },
        dealerDetailLoading: true,
        dealerDetailError: null
}

export const getDealerDetail = createAsyncThunk(
        'dealers/getDealerDetailByID',
        async (dealerDetailData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`dealer/getDealerDetailByID/${dealerDetailData}`);
                        return response.data;
                } catch (dealerError: any) {
                        return rejectWithValue(dealerError.response.data || 'An error occured');
                }
        }
);

const dealerDetailSlice = createSlice({
        name: 'dealerDetail',
        initialState,
        reducers: {
                dealerDetailReset: () => initialState,
        },
        extraReducers: (builder) => {
                //get all Dealers from server
                builder.addCase(getDealerDetail.pending, (state) => {
                        state.dealerDetailLoading = true;
                        state.dealerDetailError = null;
                });
                builder.addCase(getDealerDetail.fulfilled, (state, action) => {
                        state.dealerDetailLoading = false;
                        state.dealerDetail = action.payload;
                });
                builder.addCase(getDealerDetail.rejected, (state, action) => {
                        state.dealerDetailLoading = false;
                        state.dealerDetailError = action.payload as string;
                });
        }
});

export const { dealerDetailReset } = dealerDetailSlice.actions;
export default dealerDetailSlice.reducer;
